import React, { useEffect, useState } from "react";
import {
  AppBar,
  Button,
  Toolbar,
  Typography,
  Box,
  TextField,
  Grid,
  Checkbox,
  Paper,
  FormControl,
  Radio,
  RadioGroup,
  FormControlLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import NewRequest from "./NewRequest";
import ChangeRequest from "./ChangeRequest";
import CancelRequest from "./CancelRequest";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Controller } from "react-hook-form";
import { toast } from "react-toastify";
import AgreementFormAlsaraya from "assets/documents/Alsaraya-PDS-Dubai-Transport-Agreement.pdf";
import SignaturePad from "./SignaturePad";
import customFetch from "hooks/fetchWrapper";
import logoImg from "assets/images/logos/logo.png";
import busImg from "assets/images/bus.png";


const Header = () => {
  const [formData, setFormData] = useState({});
  const [selectedRequestType, setSelectedRequestType] = useState(0);
  const [isChecked, setIsChecked] = useState(false);
  const [signature, setSignature] = useState(null);
  const [childrenList, setChildrenList] = useState([]);

  const StudentData = localStorage.getItem("studentdata");

  const schema = yup.object().shape({
    schoolAcademicYear: yup.string().required("School Academic Year is required"),
    admissionNo: yup.string().required("Admission No. is required"),
    date: yup.date().required("Date is required"),
    studentName: yup.string().required("Name of the student is required"),
    grade: yup.string().required("Grade is required"),
    division: yup.string().required("Division is required"),
    ...(selectedRequestType === 1 ? NewRequest.validationSchema.fields : {}),
    ...(selectedRequestType === 2 ? ChangeRequest.validationSchema.fields : {}),
    ...(selectedRequestType === 3 ? CancelRequest.validationSchema.fields : {}),
  });

  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      schoolAcademicYear: "",
      admissionNo: "",
      date: moment(),
      studentName: "",
      grade: "",
      division: "",
      oldEmirate: "",
      newEmirate: "",
      oldRoute: "",
      newRoute: "",
      oldBusStop: "",
      newBusStop: "",
      oldLocation: "",
      newLocation: "",
    },
  });

  const fillStudentFields = (student) => {
    if (!student) return;
    setValue("studentName", student.MemFName || "");
    setValue("schoolAcademicYear", (student.Session || "").replace(/[^0-9]/g, ""));
    setValue("admissionNo", student.RollNo || "");
    setValue("grade", (student.classname || "").replace(/[^0-9]/g, ""));
    setValue("division", student.section || "");
    setValue("date", moment());
    localStorage.setItem(
      "studentdata",
      JSON.stringify({
        session: student.Session,
        rollNo: student.RollNo,
        name: student.MemFName,
        class: student.classname,
        section: student.section,
      })
    );
  };

  useEffect(() => {
    const fetchStudents = async () => {
      const emailToUse = localStorage.getItem("userEmail") || "";
      let list = [];
      try {
        if (emailToUse) {
          const response = await customFetch(`students/email/${encodeURIComponent(emailToUse)}`);
          if (response && response.status && Array.isArray(response.data)) {
            list = response.data;
          } else if (Array.isArray(response)) {
            list = response;
          }
        }
      } catch (error) {
        console.error("Error fetching students for transport form:", error);
      }

      if (list.length === 0) {
        const studentsStr = localStorage.getItem("students");
        if (studentsStr) {
          try {
            const parsed = JSON.parse(studentsStr);
            if (Array.isArray(parsed)) list = parsed;
          } catch (e) { }
        }
      }

      setChildrenList(list);

      if (list.length === 1) {
        fillStudentFields(list[0]);
      } else {
        setValue("studentName", "");
        setValue("schoolAcademicYear", "");
        setValue("admissionNo", "");
        setValue("grade", "");
        setValue("division", "");
        setValue("date", moment());
      }
    };

    fetchStudents();
  }, []);

  const handleRequestTypeChange = (type) => {
    setSelectedRequestType(type);
  };

  const onSubmit = async (data) => {
    console.log("🚀 ~ onSubmit ~ data:", data);
    let relevantData;
    switch (selectedRequestType) {
      case 1:
        relevantData = {
          confirmedDateOfEntry: data.confirmedDateOfEntry,
          emirateid: data.emirate,
          routeid: data.route,
          busStopid: data.busStop,
          address: data.address,
        };
        break;
      case 2:
        relevantData = {
          oldEmirateid: data.oldEmirate,
          newEmirateid: data.newEmirate,
          oldRouteid: data.oldRoute,
          newRouteid: data.newRoute,
          oldBusStopid: data.oldBusStop,
          newBusStopid: data.newBusStop,
          oldLocation: data.oldLocation,
          newLocation: data.newLocation,
          effectiveStartDate: data.effectiveStartDate ? moment(data.effectiveStartDate).format("YYYY-MM-DD") : null,
        };
        break;
      case 3:
        relevantData = {
          emirateid: data.emirate,
          routeid: data.route,
          noticeDate: moment(data.noticeDate).format("YYYY-MM-DD"),
          cancellationDate: moment(data.cancellationDate).format("YYYY-MM-DD"),
          cancellationReason: data.cancellationReason,
        };
        break;
      default:
        relevantData = {};
    }

    const formDataWithRequestType = {
      ...relevantData,
      type: selectedRequestType,
      schoolAcademicYear: data.schoolAcademicYear,
      admissionNo: data.admissionNo,
      date: data.date ? moment(data.date).format("YYYY-MM-DD") : null,
      studentName: data.studentName,
      grade: data.grade,
      division: data.division,
      signature: signature,
      email: localStorage.getItem("userEmail") || data.email,
    };

    console.log("Form Data:", formDataWithRequestType);

    const API_BASE_URL = process.env.REACT_APP_BASE_API_URL || process.env.REACT_APP_BASE_API || "http://localhost:8000/api/";

    // -----------------------------------------------------
    toast.promise(
      async () => {
        const response = await fetch(`${API_BASE_URL}transportpdfandsend`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formDataWithRequestType),
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || "An error occurred");
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = "transportFrom.pdf";
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);

        return "PDF downloaded to your PC and email sent to the school";
      },
      {
        pending: "Submitting form and generating PDF...",
        success: {
          render({ data }) {
            return data;
          },
        },
        error: {
          render({ data }) {
            return `Error: ${data.message}`;
          },
        },
      }
    );
    // -----------------------------------------------------
  };

  const handleAgreementAlsaraya = () => {
    window.open(AgreementFormAlsaraya);
  };

  const handleCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    setIsChecked(isChecked);

    if (isChecked) {
      // Open the PDF if the checkbox is checked
      handleAgreementAlsaraya();
    }
  };

  return (
    <>
      <AppBar position="static" sx={{ backgroundColor: "white", color: "black", marginTop: 5 }}>
        <Toolbar sx={{ justifyContent: "center" }}>
          <Box
            display="flex"
            alignItems="center"
            width="78%"
            border={1}
            borderColor="black"
            mx="auto"
            sx={{ bgcolor: "#f0f0e0" }}
          >
            <Typography variant="h6" component="div" sx={{ flexGrow: 1, textAlign: "center" }}>
              <img
                src={logoImg}
                alt="Logo"
                style={{ width: "100px", height: "auto" }}
              />
            </Typography>
            <Box flexGrow={1} textAlign="center">
              <Typography variant="h5" component="div">
                AL SARAYA BUSES RENTAL LLC
              </Typography>
              <Typography variant="subtitle1" component="div">
                Transport Form
              </Typography>
            </Box>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1, textAlign: "center" }}>
              <img
                src={busImg}
                alt="Bus"
                style={{ width: "100px", height: "auto" }}
              />
            </Typography>

          </Box>
        </Toolbar>
      </AppBar>

      <Box sx={{ width: "75%", margin: "auto", mt: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="body1" component="label">
              Name of the student
            </Typography>
            <Controller
              name="studentName"
              control={control}
              render={({ field }) => (
                <FormControl fullWidth variant="standard" error={!!errors.studentName}>
                  <Select
                    {...field}
                    value={field.value || ""}
                    onChange={(e) => {
                      const selectedName = e.target.value;
                      field.onChange(selectedName);
                      const found = childrenList.find((s) => s.MemFName === selectedName);
                      if (found) {
                        fillStudentFields(found);
                      }
                    }}
                    displayEmpty
                    disableUnderline
                    sx={{
                      borderBottom: "1px solid black",
                      "&:before, &:after": { display: "none" },
                    }}
                  >
                    <MenuItem value="" disabled>
                      <em>Select Student</em>
                    </MenuItem>
                    {childrenList.map((child, idx) => (
                      <MenuItem key={child.RollNo || idx} value={child.MemFName}>
                        {child.MemFName} ({child.RollNo || "No ADM"})
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            />
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body1" component="label">
              Grade
            </Typography>
            <Controller
              name="grade"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  variant="standard"
                  error={!!errors.grade}
                  helperText={errors.grade?.message}
                  InputProps={{ readOnly: true, disableUnderline: true }}
                  sx={{
                    cursor: "not-allowed",
                    "& .MuiInput-root": {
                      cursor: "not-allowed",
                      borderBottom: "1px solid black",
                      "&:before, &:after": { display: "none" },
                    },
                    "& .MuiInputBase-input": {
                      cursor: "not-allowed",
                    },
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body1" component="label">
              Division
            </Typography>
            <Controller
              name="division"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  variant="standard"
                  error={!!errors.division}
                  helperText={errors.division?.message}
                  InputProps={{ readOnly: true, disableUnderline: true }}
                  sx={{
                    cursor: "not-allowed",
                    "& .MuiInput-root": {
                      cursor: "not-allowed",
                      borderBottom: "1px solid black",
                      "&:before, &:after": { display: "none" },
                    },
                    "& .MuiInputBase-input": {
                      cursor: "not-allowed",
                    },
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={4}>
            <Typography variant="body1" component="label">
              School Academic Year
            </Typography>
            <Controller
              name="schoolAcademicYear"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  variant="standard"
                  error={!!errors.schoolAcademicYear}
                  helperText={errors.schoolAcademicYear?.message}
                  InputProps={{ readOnly: true, disableUnderline: true }}
                  sx={{
                    cursor: "not-allowed",
                    "& .MuiInput-root": {
                      cursor: "not-allowed",
                      borderBottom: "1px solid black",
                      "&:before, &:after": { display: "none" },
                    },
                    "& .MuiInputBase-input": {
                      cursor: "not-allowed",
                    },
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={4}>
            <Typography variant="body1" component="label">
              Admission No.
            </Typography>
            <Controller
              name="admissionNo"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  variant="standard"
                  error={!!errors.admissionNo}
                  helperText={errors.admissionNo?.message}
                  InputProps={{ readOnly: true, disableUnderline: true }}
                  sx={{
                    cursor: "not-allowed",
                    "& .MuiInput-root": {
                      cursor: "not-allowed",
                      borderBottom: "1px solid black",
                      "&:before, &:after": { display: "none" },
                    },
                    "& .MuiInputBase-input": {
                      cursor: "not-allowed",
                    },
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={4} sx={{ display: "flex", flexDirection: "column" }}>
            <Typography variant="body1" component="label">
              Date:
            </Typography>
            <Controller
              name="date"
              control={control}
              render={({ field }) => (
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    {...field}
                    disabled={true}
                    slotProps={{
                      textField: {
                        variant: "standard",
                        size: "small",
                        error: !!errors.date,
                        helperText: errors.date?.message,
                        sx: {
                          width: "100%",
                          cursor: "not-allowed",
                          "& .MuiInput-root": {
                            cursor: "not-allowed",
                            borderBottom: "1px solid black",
                            "&:before, &:after": { display: "none" },
                          },
                          "& input": {
                            cursor: "not-allowed",
                            fontSize: { xs: "0.6rem", md: "0.8rem", xl: "1.2rem" },
                            textAlign: "center",
                            marginTop: "-5px",
                          },
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              )}
            />
          </Grid>
          {/* <Grid item xs={3}>
            <Typography variant="body1" component="label">
              Mother telephone
            </Typography>
            <Controller
              name="mothertel"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  variant="standard"
                  error={!!errors.division}
                  helperText={errors.division?.message}
                  InputProps={{ disableUnderline: true }}
                  sx={{
                    "& .MuiInput-root": {
                      borderBottom: "1px solid black",
                      "&:before, &:after": { display: "none" },
                    },
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body1" component="label">
              Mother email
            </Typography>
            <Controller
              name="motheremail"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  variant="standard"
                  error={!!errors.division}
                  helperText={errors.division?.message}
                  InputProps={{ disableUnderline: true }}
                  sx={{
                    "& .MuiInput-root": {
                      borderBottom: "1px solid black",
                      "&:before, &:after": { display: "none" },
                    },
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body1" component="label">
              Father telephone
            </Typography>
            <Controller
              name="fathertel"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  variant="standard"
                  error={!!errors.division}
                  helperText={errors.division?.message}
                  InputProps={{ disableUnderline: true }}
                  sx={{
                    "& .MuiInput-root": {
                      borderBottom: "1px solid black",
                      "&:before, &:after": { display: "none" },
                    },
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body1" component="label">
              Father email
            </Typography>
            <Controller
              name="fatheremail"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  variant="standard"
                  error={!!errors.division}
                  helperText={errors.division?.message}
                  InputProps={{ disableUnderline: true }}
                  sx={{
                    "& .MuiInput-root": {
                      borderBottom: "1px solid black",
                      "&:before, &:after": { display: "none" },
                    },
                  }}
                />
              )}
            />
          </Grid> */}
        </Grid>
      </Box>
      {/* Section for request type buttons */}
      <Box sx={{ width: "75%", margin: "auto", mt: 3 }}>
        <Typography
          variant="h6"
          component="h2"
          sx={{ textAlign: "center", fontWeight: "bold", marginY: 4 }}
        >
          Select a service type
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Button
              variant={selectedRequestType === 1 ? "contained" : "outlined"}
              color="primary"
              fullWidth
              onClick={() => handleRequestTypeChange(1)}
              sx={{ py: 2 }}
            >
              NEW TRANSPORT REQUEST
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button
              variant={selectedRequestType === 2 ? "contained" : "outlined"}
              color="primary"
              fullWidth
              onClick={() => handleRequestTypeChange(2)}
              sx={{ py: 2 }}
            >
              BUS OR STOP CHANGE REQUEST
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button
              variant={selectedRequestType === 3 ? "contained" : "outlined"}
              color="primary"
              fullWidth
              onClick={() => handleRequestTypeChange(3)}
              sx={{ py: 2 }}
            >
              TRANSPORT CANCELLATION REQUEST
            </Button>
          </Grid>
        </Grid>
      </Box>

      {selectedRequestType === 1 && <NewRequest control={control} errors={errors} setValue={setValue} />}

      {selectedRequestType === 2 && <ChangeRequest control={control} errors={errors} setValue={setValue} />}

      {selectedRequestType === 3 && <CancelRequest control={control} errors={errors} setValue={setValue} />}

      <Box sx={{ width: "75%", margin: "auto", mt: 3 }}>
        <Paper elevation={0} sx={{ border: "1px solid black", p: 2 }}>
          <Typography variant="subtitle1" component="div" sx={{ fontWeight: "bold", mb: 2 }}>
            Terms and conditions of school bus service:
          </Typography>

          <Box display="flex" flexDirection="column" alignItems="left" sx={{ mb: 2 }}>
            <Box sx={{ width: "510px" }}>
              {isChecked && (
                <Controller
                  name="signature"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <SignaturePad
                      onSave={(signatureData) => {
                        field.onChange(signatureData);
                        setSignature(signatureData);
                      }}
                    />
                  )}
                />
              )}
            </Box>
            {errors.signature && (
              <Typography color="error" variant="caption">
                {errors.signature.message}
              </Typography>
            )}
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Checkbox size="small" onChange={handleCheckboxChange} sx={{ mr: 1 }} />
              <Typography variant="body2" component="div">
                I have read and understood the Terms & Conditions related to the school bus
                logistics and confirm my acceptance.
              </Typography>
            </Box>
          </Box>

          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Typography variant="body2" component="label">
                Parent's Signature & Date
              </Typography>
              <TextField
                fullWidth
                variant="standard"
                InputProps={{ disableUnderline: true }}
                sx={{
                  "& .MuiInput-root": {
                    borderBottom: "1px solid black",
                    "&:before, &:after": { display: "none" },
                  },
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2" component="label">
                Mobile Number
              </Typography>
              <TextField
                fullWidth
                variant="standard"
                InputProps={{ disableUnderline: true }}
                sx={{
                  "& .MuiInput-root": {
                    borderBottom: "1px solid black",
                    "&:before, &:after": { display: "none" },
                  },
                }}
              />
            </Grid>
          </Grid>
        </Paper>
      </Box>
      {/* Hidden office use sections per client request */}
      {false && (
        <>
          <Box sx={{ width: "75%", margin: "auto", mt: 3 }}>
            <Paper elevation={0} sx={{ border: "1px solid black", p: 2 }}>
              <Typography
                variant="subtitle1"
                component="div"
                sx={{ fontWeight: "bold", bgcolor: "#e8e8e8", p: 1, mb: 2 }}
              >
                For Transport Department office use only:
              </Typography>

              <Grid container spacing={2} sx={{ mb: 2 }}>
                <Grid item xs={3}>
                  <Box display="flex" alignItems="center">
                    <Checkbox size="small" />
                    <Typography variant="body2">New Transport</Typography>
                  </Box>
                </Grid>
                <Grid item xs={3}>
                  <Box display="flex" alignItems="center">
                    <Checkbox size="small" />
                    <Typography variant="body2">Route Change</Typography>
                  </Box>
                </Grid>
                <Grid item xs={3}>
                  <Box display="flex" alignItems="center">
                    <Checkbox size="small" />
                    <Typography variant="body2">Stop Change</Typography>
                  </Box>
                </Grid>
                <Grid item xs={3}>
                  <Box display="flex" alignItems="center">
                    <Checkbox size="small" />
                    <Typography variant="body2">Transport Cancellation - OT / TC</Typography>
                  </Box>
                </Grid>
              </Grid>

              <Grid container spacing={2}>
                <Grid item xs={8}>
                  <Typography variant="body2" component="label">
                    Bus Route Name:
                  </Typography>
                  <TextField
                    fullWidth
                    variant="standard"
                    InputProps={{ disableUnderline: true }}
                    sx={{
                      "& .MuiInput-root": {
                        borderBottom: "1px solid black",
                        "&:before, &:after": { display: "none" },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={4}></Grid>
                <Grid item xs={8}>
                  <Typography variant="body2" component="label">
                    Bus Stop Name:
                  </Typography>
                  <TextField
                    fullWidth
                    variant="standard"
                    InputProps={{ disableUnderline: true }}
                    sx={{
                      "& .MuiInput-root": {
                        borderBottom: "1px solid black",
                        "&:before, &:after": { display: "none" },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={4}></Grid>
                <Grid item xs={4}>
                  <Typography variant="body2" component="label">
                    Bus Route No.
                  </Typography>
                  <TextField
                    fullWidth
                    variant="standard"
                    InputProps={{ disableUnderline: true }}
                    sx={{
                      "& .MuiInput-root": {
                        borderBottom: "1px solid black",
                        "&:before, &:after": { display: "none" },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2" component="label">
                    Bus Stop Code :
                  </Typography>
                  <TextField
                    fullWidth
                    variant="standard"
                    InputProps={{ disableUnderline: true }}
                    sx={{
                      "& .MuiInput-root": {
                        borderBottom: "1px solid black",
                        "&:before, &:after": { display: "none" },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={4}></Grid>
                <Grid item xs={4}>
                  <Typography variant="body2" component="label">
                    With effect from
                  </Typography>
                  <TextField
                    fullWidth
                    variant="standard"
                    InputProps={{ disableUnderline: true }}
                    sx={{
                      "& .MuiInput-root": {
                        borderBottom: "1px solid black",
                        "&:before, &:after": { display: "none" },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2" component="label">
                    Area Code :
                  </Typography>
                  <TextField
                    fullWidth
                    variant="standard"
                    InputProps={{ disableUnderline: true }}
                    sx={{
                      "& .MuiInput-root": {
                        borderBottom: "1px solid black",
                        "&:before, &:after": { display: "none" },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2" component="label">
                    Authorised Signature & Date
                  </Typography>
                  <TextField
                    fullWidth
                    variant="standard"
                    InputProps={{ disableUnderline: true }}
                    sx={{
                      "& .MuiInput-root": {
                        borderBottom: "1px solid black",
                        "&:before, &:after": { display: "none" },
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Box>

          <Box sx={{ width: "75%", margin: "auto", mt: 3 }}>
            <Paper elevation={0} sx={{ border: "1px solid black", p: 2 }}>
              <Grid container spacing={2}>
                {/* For Accounts Department Office use only */}
                <Grid item xs={6} sx={{ borderRight: "1px solid black" }}>
                  <Typography
                    variant="subtitle1"
                    component="div"
                    sx={{ fontWeight: "bold", bgcolor: "#e8e8e8", p: 1, mb: 2 }}
                  >
                    For Accounts Department Office use only:
                  </Typography>

                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Typography variant="body2" component="label">
                        Application received date
                      </Typography>
                      <TextField
                        fullWidth
                        variant="standard"
                        InputProps={{ disableUnderline: true }}
                        sx={{
                          "& .MuiInput-root": {
                            borderBottom: "1px solid black",
                            "&:before, &:after": { display: "none" },
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body2" component="label">
                        Bus Fees for Term ( √ )
                      </Typography>
                      <Box display="flex" justifyContent="space-between" mt={1}>
                        <FormControl component="fieldset">
                          <RadioGroup row>
                            <FormControlLabel
                              value="first"
                              control={<Radio size="small" />}
                              label="First"
                            />
                            <FormControlLabel
                              value="second"
                              control={<Radio size="small" />}
                              label="Second"
                            />
                            <FormControlLabel
                              value="third"
                              control={<Radio size="small" />}
                              label="Third"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body2" component="label">
                        Total Fees ( in AED)
                      </Typography>
                      <TextField
                        fullWidth
                        variant="standard"
                        InputProps={{ disableUnderline: true }}
                        sx={{
                          "& .MuiInput-root": {
                            borderBottom: "1px solid black",
                            "&:before, &:after": { display: "none" },
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sx={{ mt: 4 }}>
                      <Typography variant="body2" component="label">
                        Authorised Signature & Date (Accounts Department)
                      </Typography>
                      <TextField
                        fullWidth
                        variant="standard"
                        InputProps={{ disableUnderline: true }}
                        sx={{
                          "& .MuiInput-root": {
                            borderBottom: "1px solid black",
                            "&:before, &:after": { display: "none" },
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* For CLP Department Office use only */}
                <Grid item xs={6}>
                  <Typography
                    variant="subtitle1"
                    component="div"
                    sx={{ fontWeight: "bold", bgcolor: "#e8e8e8", p: 1, mb: 2 }}
                  >
                    For CLP Department Office use only:
                  </Typography>

                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Typography variant="body2" component="label">
                        Application received date
                      </Typography>
                      <TextField
                        fullWidth
                        variant="standard"
                        InputProps={{ disableUnderline: true }}
                        sx={{
                          "& .MuiInput-root": {
                            borderBottom: "1px solid black",
                            "&:before, &:after": { display: "none" },
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body2" component="label">
                        Student profile updated by
                      </Typography>
                      <TextField
                        fullWidth
                        variant="standard"
                        InputProps={{ disableUnderline: true }}
                        sx={{
                          "& .MuiInput-root": {
                            borderBottom: "1px solid black",
                            "&:before, &:after": { display: "none" },
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body2" component="label">
                        RFID Issued Date
                      </Typography>
                      <TextField
                        fullWidth
                        variant="standard"
                        InputProps={{ disableUnderline: true }}
                        sx={{
                          "& .MuiInput-root": {
                            borderBottom: "1px solid black",
                            "&:before, &:after": { display: "none" },
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sx={{ mt: 4 }}>
                      <Typography variant="body2" component="label">
                        Authorised Signature & Date (CLP Department - School)
                      </Typography>
                      <TextField
                        fullWidth
                        variant="standard"
                        InputProps={{ disableUnderline: true }}
                        sx={{
                          "& .MuiInput-root": {
                            borderBottom: "1px solid black",
                            "&:before, &:after": { display: "none" },
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Box>

          <Box sx={{ width: "75%", margin: "auto", mt: 3 }}>
            <Paper elevation={0} sx={{ border: "1px solid black", p: 2 }}>
              <Typography
                variant="subtitle1"
                component="div"
                sx={{ fontWeight: "bold", bgcolor: "#e8e8e8", p: 1, mb: 2, textAlign: "center" }}
              >
                Information slip for driver
              </Typography>

              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <Typography variant="body2" component="label">
                    Student's Name
                  </Typography>
                  <Controller
                    name="studentName"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        variant="standard"
                        error={!!errors.studentName}
                        helperText={errors.studentName?.message}
                        InputProps={{ disableUnderline: true }}
                        sx={{
                          "& .MuiInput-root": {
                            borderBottom: "1px solid black",
                            "&:before, &:after": { display: "none" },
                          },
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2" component="label">
                    Grade & Div
                  </Typography>
                  <Controller
                    name="grade"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        variant="standard"
                        error={!!errors.grade}
                        helperText={errors.grade?.message}
                        InputProps={{ disableUnderline: true }}
                        sx={{
                          "& .MuiInput-root": {
                            borderBottom: "1px solid black",
                            "&:before, &:after": { display: "none" },
                          },
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2" component="label">
                    Admission No.
                  </Typography>
                  <Controller
                    name="admissionNo"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        variant="standard"
                        error={!!errors.admissionNo}
                        helperText={errors.admissionNo?.message}
                        InputProps={{ disableUnderline: true }}
                        sx={{
                          "& .MuiInput-root": {
                            borderBottom: "1px solid black",
                            "&:before, &:after": { display: "none" },
                          },
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Box display="flex" alignItems="center">
                    <Typography variant="body2" component="span">
                      The above student has{" "}
                    </Typography>
                    <FormControl component="fieldset" sx={{ mx: 1 }}>
                      <RadioGroup row>
                        <FormControlLabel
                          value="permission"
                          control={<Radio size="small" />}
                          label="Permission"
                        />
                        <FormControlLabel
                          value="discontinue"
                          control={<Radio size="small" />}
                          label="Discontinue"
                        />
                      </RadioGroup>
                    </FormControl>
                    <Typography variant="body2" component="span">
                      to ride bus route no #{" "}
                    </Typography>
                    <TextField
                      variant="standard"
                      InputProps={{ disableUnderline: true }}
                      sx={{
                        width: "50px",
                        mx: 1,
                        "& .MuiInput-root": {
                          borderBottom: "1px solid black",
                          "&:before, &:after": { display: "none" },
                        },
                      }}
                    />
                    <Typography variant="body2" component="span">
                      for{" "}
                    </Typography>
                    <TextField
                      variant="standard"
                      InputProps={{ disableUnderline: true }}
                      sx={{
                        width: "50px",
                        mx: 1,
                        "& .MuiInput-root": {
                          borderBottom: "1px solid black",
                          "&:before, &:after": { display: "none" },
                        },
                      }}
                    />
                    <Typography variant="body2" component="span">
                      day(s)
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2" component="label">
                    Starting Date:
                  </Typography>
                  <TextField
                    fullWidth
                    variant="standard"
                    InputProps={{ disableUnderline: true }}
                    sx={{
                      "& .MuiInput-root": {
                        borderBottom: "1px solid black",
                        "&:before, &:after": { display: "none" },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2" component="label">
                    Ending Date:
                  </Typography>
                  <TextField
                    fullWidth
                    variant="standard"
                    InputProps={{ disableUnderline: true }}
                    sx={{
                      "& .MuiInput-root": {
                        borderBottom: "1px solid black",
                        "&:before, &:after": { display: "none" },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2" component="label">
                    Reason:
                  </Typography>
                  <TextField
                    fullWidth
                    variant="standard"
                    InputProps={{ disableUnderline: true }}
                    sx={{
                      "& .MuiInput-root": {
                        borderBottom: "1px solid black",
                        "&:before, &:after": { display: "none" },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2" component="label">
                    Destination (Stop Name)
                  </Typography>
                  <TextField
                    fullWidth
                    variant="standard"
                    InputProps={{ disableUnderline: true }}
                    sx={{
                      "& .MuiInput-root": {
                        borderBottom: "1px solid black",
                        "&:before, &:after": { display: "none" },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2" component="label">
                    Authorised Signature:
                  </Typography>
                  <TextField
                    fullWidth
                    variant="standard"
                    InputProps={{ disableUnderline: true }}
                    sx={{
                      "& .MuiInput-root": {
                        borderBottom: "1px solid black",
                        "&:before, &:after": { display: "none" },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2" component="div" sx={{ fontStyle: "italic" }}>
                    This pass must be shown to bus driver upon entering bus.
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2" component="label">
                    Date:
                  </Typography>
                  <TextField
                    fullWidth
                    variant="standard"
                    InputProps={{ disableUnderline: true }}
                    sx={{
                      "& .MuiInput-root": {
                        borderBottom: "1px solid black",
                        "&:before, &:after": { display: "none" },
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Box>
        </>
      )}

      <Box sx={{ width: "25%", margin: "auto", my: 5 }}>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleSubmit(onSubmit)}
          sx={{ py: 2 }}
          disabled={!isChecked}
        >
          Submit
        </Button>
      </Box>
    </>
  );
};

export default Header;
